module.exports = __webpack_public_path__ + "static/media/BannerWithImage@3x.2ce881424d41f870dc7e1a4dd0635890.jpg";